import { interpolate1d } from '../../utils/helpers/math';
import { TurnSegment, FspSegment, MergedFspSegment } from '../../types/turnFsp';

/**
 * Merge FSP segments with angle values from corresponding turn segments
 *
 * For each FSP timestamp, we find the closest turn timestamp and
 * take the corresponding angle value.
 *
 * @param turnSegments - high-frequency angle segments
 * @param fspSegments - low-frequency FSP segments
 * @returns array of merged segments
 */
export function mergeAngleAndFsp(turnSegments: TurnSegment[], fspSegments: FspSegment[]): MergedFspSegment[] {
  const merged: MergedFspSegment[] = [];

  for (const fspSeg of fspSegments) {
    const turnSeg = turnSegments.find((t) => t.turnNumberID === fspSeg.turnNumberID);
    if (!turnSeg) continue;

    const { timestamps: turnT, angleData } = turnSeg;
    const { fspTimestamps, fspSensorData } = fspSeg;

    const angleValues: number[] = [];

    // for each FSP timestamp, find closest angle timestamp
    for (const fspTs of fspTimestamps) {
      let closestIdx = 0;
      let minDiff = Math.abs(turnT[0] - fspTs);
      for (let i = 1; i < turnT.length; i++) {
        const diff = Math.abs(turnT[i] - fspTs);
        if (diff < minDiff) {
          minDiff = diff;
          closestIdx = i;
        }
      }
      angleValues.push(angleData[closestIdx]);
    }

    merged.push({
      turnNumberID: fspSeg.turnNumberID,
      angleValues,
      fspSensorData,
    });
  }
  return merged;
}

/**
 * Merge FSP segments with angle values from corresponding turn segments
 *
 * For each FSP timestamp, we find the closest turn timestamp and
 * take the corresponding angle value.
 *
 * @param turnSegments - high-frequency angle segments
 * @param fspSegments - low-frequency FSP segments
 * @returns array of merged segments
 */
export function mergeAngleAndFspWithInterpolation(turnSegments: TurnSegment[], fspSegments: FspSegment[]): MergedFspSegment[] {
  const merged: MergedFspSegment[] = [];

  console.log('segments are', turnSegments, fspSegments);

  for (const fspSeg of fspSegments) {
    const turnSeg = turnSegments.find((t) => t.turnNumberID === fspSeg.turnNumberID);
    if (!turnSeg) continue;

    let { timestamps: turnT, angleData } = turnSeg;
    const { fspTimestamps, fspSensorData } = fspSeg;

    const angleValues: number[] = [];

    // for each FSP timestamp, interpolate angle timestamp
    for (const fspTs of fspTimestamps) {
      angleValues.push(interpolate1d(turnT, angleData, fspTs));
    }
    merged.push({
      turnNumberID: fspSeg.turnNumberID,
      angleValues,
      fspSensorData,
    });
  }

  console.log('merged is', merged);
  return merged;
}
